import styled from 'styled-components';

export const StyledGhostModeWrapper = styled.div`
  display: flex;
  padding: ${({ theme }): string => `${theme.spacers!.spacer02} ${theme.spacers!.spacer06}`};
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  background-color: ${({ theme }): string => theme.admanColors!.blue.light.bg1[4]};

  & > div {
    display: inline-flex;
    height: 20px;

    div {
      margin-right: ${({ theme }): string => theme.spacers!.spacer04};
      padding: 0 ${({ theme }): string => theme.spacers!.spacer03};
      justify-content: center;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
      border-radius: 4px;
      background-color: ${({ theme }): string => theme.admanColors!.gray.light.fg[0]};
      color: ${({ theme }): string => theme.admanColors!.gray.light.bg0[0]};
      text-align: center;
      font-size: 10px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: 0;
      text-transform: uppercase;
    }

    span {
      color: ${({ theme }): string => theme.admanColors!.gray.light.fg[0]};
      text-align: right;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 140%;
    }
  }
`;

export const StyledLogOut = styled.span`
  color: ${({ theme }): string => theme.admanColors!.gray.light.fg[0]};
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  text-decoration-line: underline;
  cursor: pointer;
`;
